var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExhMarkerImageSrcSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_2839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 20C43 29.0601 36.9757 36.7131 28.7143 39.1718C25.8571 40 23 45 23 45C23 45 20.1429 40 17.2857 39.1718C9.02432 36.7131 3 29.0601 3 20C3 8.9543 11.9543 0 23 0C34.0457 0 43 8.9543 43 20Z",
    fill: "#05B88D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0426 20.7857C25.2613 20.7857 23.0009 23.046 23.0009 25.8273C25.7822 25.8273 28.0426 23.567 28.0426 20.7857ZM17.9592 20.7857C17.9592 23.567 20.2196 25.8273 23.0009 25.8273C23.0009 23.046 20.7406 20.7857 17.9592 20.7857ZM19.6398 19.1303C19.6398 19.853 20.228 20.4411 20.9506 20.4411C21.2279 20.4411 21.48 20.3571 21.6985 20.2059L21.6901 20.3067C21.6901 21.0293 22.2783 21.6175 23.0009 21.6175C23.7235 21.6175 24.3117 21.0293 24.3117 20.3067L24.3033 20.2059C24.5134 20.3487 24.7739 20.4411 25.0512 20.4411C25.7738 20.4411 26.362 19.853 26.362 19.1303C26.362 18.6093 26.0511 18.1556 25.6142 17.9455C26.0511 17.7439 26.362 17.2901 26.362 16.7691C26.362 16.0465 25.7738 15.4583 25.0512 15.4583C24.7739 15.4583 24.5218 15.5423 24.3033 15.6936L24.3117 15.5927C24.3117 14.8701 23.7235 14.2819 23.0009 14.2819C22.2783 14.2819 21.6901 14.8701 21.6901 15.5927L21.6985 15.6936C21.4884 15.5423 21.2279 15.4583 20.9506 15.4583C20.228 15.4583 19.6398 16.0465 19.6398 16.7691C19.6398 17.2901 19.9507 17.7439 20.3876 17.9539C19.9507 18.1556 19.6398 18.6093 19.6398 19.1303ZM23.0009 16.6347C23.7235 16.6347 24.3117 17.2229 24.3117 17.9455C24.3117 18.6682 23.7235 19.2564 23.0009 19.2564C22.2783 19.2564 21.6901 18.6682 21.6901 17.9455C21.6901 17.2229 22.2783 16.6347 23.0009 16.6347Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5217 11.5227H31.4801V28.4811H14.5217V11.5227ZM15.8967 12.8977V27.1061H30.1051V12.8977H15.8967Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_2839",
    x: 0,
    y: 0,
    width: 46,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_2839"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_2839",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhMarkerImageSrcSelect);
export default __webpack_public_path__ + "static/media/exhMarkerImageSrc_select.cb4c32a9fa1153ae61c78fbec889bdc1.svg";
export { ForwardRef as ReactComponent };